import { init as initAPM } from '@elastic/apm-rum'

const apm = initAPM({
  serviceName: 'Sitehub frontend react',
  serverUrl:
    'https://178a4a24cce04230b73e7c18c9294075.apm.us-central1.gcp.cloud.es.io:443',
  serviceVersion: '1.0.1',
  environment: 'production'
})

export default apm
